import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IStopAddress } from '@okcargo-apps/shared-domain';

@Component({
  selector: 'lib-freight-carrier-inprogress-card-address',
  templateUrl: './freight-carrier-inprogress-card-address.component.html',
  styleUrls: ['./freight-carrier-inprogress-card-address.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule],
})
export class FreightCarrierInprogressCardAddressComponent {
  readonly address = input.required<IStopAddress>();

  // constructor() {}
}
